module.exports = __webpack_public_path__ + "static/media/a.07cc21cc.jpg";